import type { RequestFn } from '../../client';

export class Cache {
  constructor(private readonly request: RequestFn) {}

  /** Invalidate a cache entry by key. `POST /cache/invalidate/{key}` */
  async invalidate(key: string): Promise<Record<string, unknown>> {
    return this.request('POST', `/cache/invalidate/${encodeURIComponent(key)}`);
  }
}
